<template>
	<div
		class="mx-auto flex w-full items-center justify-center bg-won-blue py-4 pl-6"
	>
		<img 
			:src="BeachCommuteLogo" 
			alt="WonsultingAi-Logo" 
			class="mr-4 h-9"
		/>
		<span class="text-xl text-white">X</span>
		<img 
			:src="'/img/logo.svg?id=36d75e6e63946874eae5'" 
			alt=""
			class="ml-4 h-8 w-auto" 
			style="filter: brightness(0) invert(1)"
		/>
	</div>
</template>

<script setup>
const BeachCommuteLogo = '/img/beach-comute-logo.png';
</script>
